import React from 'react';
import {Column} from '@ant-design/plots';
import {Card, Tooltip} from 'antd';
import {NoDataPlaceholder, truncateStr} from '../../../utils/helpers';
import {InfoCircleOutlined} from '@ant-design/icons';

type EarningsAndCLicksProps = {
    earningsAcrossCampaigns: any,
    clicksPerCampaign: any
};

interface DataItem {
    campaign_name: string;
    value: number;
    type: string;
}

const FONT = 'Poppins';

const ClicksAndEarningsGraph = ({earningsAcrossCampaigns, clicksPerCampaign}: EarningsAndCLicksProps) => {
    const earningsAcrossCampaignsRaw = earningsAcrossCampaigns || [];

    const earningsSeries = (earningsAcrossCampaignsRaw || []).map(
        ({earningsFromClicks, campaign_name, ...rest}: any) => ({
            value: earningsFromClicks,
            type: 'Earnings from clicks',
            campaign_name,
            ...rest
        })
    );

    const clicksSeries = (clicksPerCampaign || []).map(
        ({numberOfClicks, campaign_name, ...rest}: any) => ({
            value: numberOfClicks,
            type: 'Clicks',
            campaign_name,
            ...rest
        })
    );

    const depositSeries = (earningsAcrossCampaignsRaw || []).map(
        ({depositCommission = 0, campaign_name, ...rest}: any) => ({
            value: depositCommission,
            type: 'Earnings from deposit commission',
            campaign_name,
            ...rest
        })
    );

    const data: DataItem[] = [...clicksSeries, ...earningsSeries, ...depositSeries];

    const config = {
        data: data || [],
        xField: 'campaign_name',
        yField: 'value',
        colorField: 'type',
        isGroup: true,
        style: {inset: 5},
        responsive: true,
        height: 320,
        autoFit: true,
        axis: {
            x: {
                labelFontFamily: FONT,
                labelAutoHide: true,
                labelAutoRotate: true,
                labelRotate: -0.6,
                formatter: (v: string) => truncateStr(v, 12)
            },
            y: {labelFontFamily: FONT},
        },
        tooltip: {
            title: {style: {fontFamily: FONT}},
            itemName: {style: {fontFamily: FONT}},
            itemValue: {style: {fontFamily: FONT}}
        },
        legend: {position: 'top'}
    };

    const ClicksAndEarningsCardTitle = () => (
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <span>Clicks and earnings across campaigns</span>
            <Tooltip title="Number of clicks and respective earnings gained for each campaign">
                <InfoCircleOutlined/>
            </Tooltip>
        </div>
    );

    return (
        <Card title={<ClicksAndEarningsCardTitle/>}>
            {data.length > 0 ? (<Column {...config} />) : (<NoDataPlaceholder message="No data to display"/>)}
        </Card>
    );
};

export default ClicksAndEarningsGraph;